// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610131555/js/" + chunkId + "." + {"44":"e01a229f","225":"020572f1","481":"3c4bed81","486":"6a95f2b2","770":"bd1caee6"}[chunkId] + ".0.033295239736168436.chunk.js";
};